/**
 * Generates a random ID for client-side purposes.
 */
export function naiveRandomId() {
    return Date.now().toString(36) + Math.random().toString(36).substring(2, 9);
}
//# sourceMappingURL=naiveRandomId.js.map